import { Component } from '@angular/core';

@Component({
    selector: 'app-section-technologies',
    templateUrl: './section-technologies.component.html',
    styleUrls: ['./section-technologies.component.scss'],
    standalone: false
})
export class SectionTechnologiesComponent {

  constructor() { }

}
